export default function AvaexInfo({ data }) {
  return (
    <div className="mb-2 rtl">
      <div className="d-flex flex-wrap gap-3 align-items-center justify-content-between bg-white shadow rounded px-4 py-4 text-center">
        <div className="d-flex align-items-center">
          <div className="d-flex align-items-center"></div>

          <div className="stats-card h-100 text-center">
            <div className="card-body">
              <h6 className="card-subtitle mb-1 text-muted">موجودی کیف پول</h6>
              <p
                id="stat-wallet"
                className="card-text stats-value text-success fw-bold"
              >
                {data?.user?.wallet?.toLocaleString()} ﷼
              </p>
            </div>
          </div>
        </div>

        <div className="d-flex align-items-center">
          <div className="stats-card h-100 text-center">
            <div className="card-body">
              <a
                className="btn btn-sm btn-info p-2 border w-auto text-muted fw-bold"
                style={{ borderRadius: "50px" }}
                href="https://avaex.ir/prewallet"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="/icons/wallet.svg" style={{ maxWidth: "50px" }} />
                افزایش موجودی
              </a>
            </div>
          </div>
        </div>

        <div className="d-flex align-items-center">
          <div className="stats-card h-100 text-center">
            <div className="card-body">
              <h6 className="card-subtitle mb-1 text-muted">
                مبلغ بستانکاری COD
              </h6>
              <p
                id="stat-cod"
                className="card-text stats-value text-success fw-bold"
              >
                {data?.user?.codFlow?.toLocaleString()} ﷼
              </p>
            </div>
          </div>
        </div>

        <div className="d-flex align-items-center">
          <div className="stats-card h-100 text-center">
            <div className="card-body">
              <h6 className="card-subtitle mb-1 text-muted">تعداد مرسولات</h6>
              <p
                id="stat-shipment"
                className="card-text stats-value text-dark fw-bold"
              >
                ماه {data.shipment.inMonth} / هفته {data.shipment.inWeek} / روز{" "}
                {data.shipment.inDay}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
